import React, { Component } from 'react'
import NumberFormat from 'react-number-format'
import InputMoment from 'input-moment'
import moment from 'moment-timezone'

// CSS
import '../../../css/input-moment/input-moment.css'

class SaleCodeItemFields extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { item, index } = this.props
        const { updateLoading, updateDeleting } = item

        return (
            [
                <td className="item-title" key={'title'}>
                    {!!item.errors && !!item.errors.code &&
                        <div className="error msg_animate">{item.errors.code}</div>
                    }
                    <input type="text" value={item.code} placeholder="SALESCODE" maxLength="50" disabled={updateLoading || updateDeleting}
                        onKeyPress={e => this.props.handleKeyPress(e)}
                        onChange={e => this.props.handleChange(e.target.value, index, 'code')}
                    />
                </td>,
                <td className="item-price" key={'price'}>
                    {!!item.errors && !!item.errors.value &&
                        <div className="error msg_animate">{item.errors.value}</div>
                    }
                    <NumberFormat value={!!item.value ? item.value : ''} placeholder="0.00" prefix={item.sale_type ? '$' : ''} suffix={!item.sale_type ? '%' : ''} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} disabled={updateLoading || updateDeleting}
                        onKeyPress={e => this.props.handleKeyPress(e)}
                        onValueChange={e => this.props.handleChange(e.value, index, 'value')}
                    />
                </td>,
                <td className="item-price-type" key={'sale_type'}>
                    {!!item.errors && !!item.errors.sale_type &&
                        <div className="error msg_animate">{item.errors.sale_type}</div>
                    }
                    <label className="tgl">
                        <input type="checkbox" value="dollar" checked={item.sale_type} disabled={updateLoading || updateDeleting}
                            onChange={e => this.props.handleCheckboxClick(index, 'sale_type')}
                        />
                        <span data-on="$" data-off="%"></span>
                    </label>
                </td>,
                <td className="item-min-sale" key={'min_sale_amount'}>
                    {!!item.errors && !!item.errors.min_sale_amount &&
                        <div className="error msg_animate">{item.errors.min_sale_amount}</div>
                    }
                    <NumberFormat value={!!item.min_sale_amount ? item.min_sale_amount : ''} placeholder="0.00" prefix={'$'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} disabled={updateLoading || updateDeleting}
                        onKeyPress={e => this.props.handleKeyPress(e)}
                        onValueChange={e => this.props.handleChange(e.value, index, 'min_sale_amount')}
                    />
                </td>,
                <td className="item-expiry" key={'expires'}>
                    {!!item.errors && !!item.errors.expires &&
                        <div className="error msg_animate">{item.errors.expires}</div>
                    }
                    <input type="text" className="readonly-clickable" placeholder="Expiry" maxLength="255" readOnly disabled={updateLoading || updateDeleting}
                        value={!!item.expires ? moment(item.expires.toString()).format('YYYY-MM-DD hh:mm:ss a') : ''}
                        onClick={() => this.setState({ showEndDialog: !this.state.showEndDialog })}
                    />
                    {this.state.showEndDialog &&
                        <InputMoment
                            className="top-margin"
                            moment={!!item.expires ? moment(item.expires) : moment()}
                            onChange={m => this.props.handleChange(m.format('YYYY-MM-DD HH:mm:ss'), index, 'expires')}
                            prevMonthIcon="icon-circle-left"
                            nextMonthIcon="icon-circle-right"
                        />
                    }
                </td>
            ]
        )
    }
}

export default SaleCodeItemFields



// WEBPACK FOOTER //
// ./src/components/admin/discounts/SaleCodeItemFields.js